import React, {useState} from 'react';
import PropTypes from 'prop-types';
import appConfig from 'config/app.config';
import {getText} from 'helpers/language-helper';
import {adminUiTexts} from 'data/ui-texts/admin-ui-texts';
import Button from 'components/ui/button/button';
import AdminHeader from './admin-header/admin-header';
import AdminTextToSpeechPopup from './admin-text-to-speech-popup/admin-text-to-speech-popup';
import AdminRefactorPlayerDataPopup from './admin-refactor-player-data-popup/admin-refactor-player-data-popup';
import './admin.scss';

const Admin = ({email, languageId, goToPage, handleLogout}) => {

	/* Text to speech (popup) */
	const [showTextToSpeechPopup, setShowTextToSpeechPopup] = useState(false);
	const toggleTextToSpeechPopup = () => {
		setShowTextToSpeechPopup(!showTextToSpeechPopup);
	};

	const [showRefactorPlayerDataPopup, setShowRefactorPlayerDataPopup] = useState(false);
	const toggleRefactorPlayerDataPopup = () => {
		setShowRefactorPlayerDataPopup(!showRefactorPlayerDataPopup);
	};

	return (
		<div className="Admin">
			<div className="Admin-header">
				<AdminHeader 
					languageId={languageId}
					email={email}
					goToPage={goToPage}
					handleLogout={handleLogout}
				/>
			</div>
			<div className="Admin-content">
				{/* Text to speech btn */}
				{appConfig.env !== 'demo' &&
					<div className="Admin-textToSpeechBtn">
						<Button 
							classes={['admin']} 
							text={getText(adminUiTexts.textToSpeechPopup.title, languageId)} 
							onClick={() => {toggleTextToSpeechPopup();}} 
						/>
					</div>
				}
				<div className="Admin-refactorPlayerDataBtn">
					<Button 
						classes={['admin']} 
						text={getText(adminUiTexts.refactorPlayerDataPopup.title, languageId)} 
						onClick={() => {toggleRefactorPlayerDataPopup();}} 
					/>
				</div>
			</div>

			{showTextToSpeechPopup && 
				<AdminTextToSpeechPopup 
					languageId={languageId}
					togglePopup={toggleTextToSpeechPopup}
				/>
			}

			{showRefactorPlayerDataPopup &&
				<AdminRefactorPlayerDataPopup 
					languageId={languageId}
					togglePopup={toggleRefactorPlayerDataPopup}
				/>}
		</div>
	);

};

Admin.propTypes = {
	email: PropTypes.string.isRequired,
	languageId: PropTypes.string.isRequired,
	goToPage: PropTypes.func.isRequired,
	handleLogout: PropTypes.func.isRequired
};

export default Admin;
